// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../v5/common/Components/IconV5.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function PageUITitle(props) {
  let __className = props.className;
  let icon = props.icon;
  let __centered = props.centered;
  let __huge = props.huge;
  let subtitle = props.subtitle;
  let huge = __huge !== undefined ? __huge : false;
  let centered = __centered !== undefined ? __centered : false;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsxs("div", {
    children: [
      icon !== undefined ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(IconV5.make, {
            icon: icon,
            size: 40
          }),
          className: "mr-5 rounded-full border border-gray-800 p-2.5 flex shrink-0 text-gray-800"
        }) : null,
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h2", {
            className: TailwindMerge.twMerge([
              "leading-tight font-light text-gray-800 m-0 [&_b]:font-bold [&_i]:italic",
              huge ? "text-[26px] md:text-[36px] lg:text-[42px]" : "text-[22px] md:text-[26px] lg:text-[32px]"
            ]),
            dangerouslySetInnerHTML: {
              __html: props.title
            }
          }),
          subtitle !== undefined ? JsxRuntime.jsx("h6", {
              children: subtitle,
              className: TailwindMerge.twMerge([
                "mt-3 font-normal leading-snug text-gray-500 md:max-w-[80%] ",
                huge ? "text-base md:text-[22px]" : "text-[13px] md:text-base"
              ])
            }) : null
        ],
        className: TailwindMerge.twMerge([
          "flex flex-col",
          centered ? "items-center" : ""
        ])
      })
    ],
    className: TailwindMerge.twMerge([
      "flex items-center mb-4 md:mb-6",
      centered ? "text-center" : "",
      className
    ])
  });
}

let make = PageUITitle;

exports.make = make;
/* IconV5 Not a pure module */
